import {Pipe, PipeTransform} from '@angular/core';
import {addCurrencyToDisplayDecimal, DisplayDecimal} from '../symbol-decimals';
import {createDisplayDecimalFromBigint} from '../symbol-decimals/display-decimal-bigint';

@Pipe({
    name: 'bigintDisplayDecimal'
})
export class BigintDisplayDecimalPipe implements PipeTransform {

    public transform(value: bigint | string, decimalCount: number, currency?: string): DisplayDecimal<string> {
        const displayDecimal = createDisplayDecimalFromBigint(value, decimalCount);

        if (currency && displayDecimal) {
            addCurrencyToDisplayDecimal(displayDecimal, currency);
        }

        return displayDecimal;
    }

}
